<template>
    <ParticleBackground v-if="fancyBackground"/>

    <div :class="fancyBackground ? '' : 'bg-gray-100'" class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0">
        <div>
            <slot name="logo" />
        </div>

        <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
            <slot />
        </div>
    </div>
</template>
<script>
import ParticleBackground from "../Components/ParticleBackground";
export default {
    components: {ParticleBackground},
    data(){
        return {
            fancyBackground: false
        }
    }
}
</script>
